import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

// Admin-only slide-over that fires errors on demand to exercise the real
// error/trace-id/toast surface. Global (not route-scoped) so it can be opened
// over whatever screen the admin is on and watch the display render in context.
interface DevPanelStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useDevPanelStore = create<DevPanelStore>()(
  devtools(
    (set) => ({
      isOpen: false,
      open: () => set({ isOpen: true }, false, 'open'),
      close: () => set({ isOpen: false }, false, 'close'),
    }),
    { name: 'DevPanelStore', enabled: import.meta.env.DEV }
  )
);

export const useDevPanel = () => useDevPanelStore((s) => s.isOpen);

/** Imperative opener for non-reactive callers (e.g. a nav button handler). */
export const openDevPanel = () => useDevPanelStore.getState().open();
